import { render } from "./kanban-view.vue?vue&type=template&id=7cfc5438"
import script from "./kanban-view.vue?vue&type=script&lang=js"
export * from "./kanban-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__